<template>
  <v-card class="mx-auto elevation-0 pa-8" max-width="550">
    <h2 class="text-h5 mb-6 font-weight-regular text-center">
      {{ $t("AccountLogin") }}
    </h2>
    <v-card-text class="pt-4 pb-4">
      <v-alert dense outlined type="error" v-if="error">
        <ul>
          <li v-for="item in error" :key="item.msg">
            {{ $t(item.msg) }}
            <router-link
              v-if="item.err_type == 1"
              class="light-blue--text"
              :to="{
                name: 'ResetPassword',
                query: { redirect: $route.query.redirect }
              }"
            >
              {{ $t("LoginAttErr") }}
            </router-link>
            <router-link
              v-if="error.err_type == 2"
              class="light-blue--text"
              :to="{ name: 'EmailVerification', params: { id: error.user_id } }"
            >
              {{ $t("Clickheretoverifyyouraccount") }}
            </router-link>
          </li>
        </ul>
      </v-alert>
      <v-form
        ref="form"
        v-model="valid"
        @submit.prevent="submit"
        lazy-validation
      >
        <v-row>
          <v-col>
            <v-text-field
              v-model="username"
              type="email"
              hide-details="auto"
              outlined
              v-bind:label="$t('EmailAddress')"
              :rules="emailRules"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="password"
              hide-details="auto"
              type="Password"
              outlined
              v-bind:label="$t('Password')"
              :rules="reqRules"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn large color="light-blue" dark block rounded type="submit">
              <span class="mr-2">{{ $t("SignIn") }}</span>
              <v-icon size="small">mdi-arrow-right-thick</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <router-link
              class="grey--text text-decoration-none font-weight-bold"
              :to="{
                name: 'Register',
                query: { redirect: $route.query.redirect }
              }"
            >
              {{ $t("CreateyourAccount") }}
            </router-link>
          </v-col>
          <v-col cols="12" md="6" class="text-md-right">
            <router-link
              class="grey--text text-decoration-none font-weight-bold"
              :to="{
                name: 'ResetPassword',
                query: { redirect: $route.query.redirect }
              }"
            >
              {{ $t("Forgotpassword") }}
            </router-link>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
// @ is an alias to /src
import AuthService from "@/services/AuthService";

export default {
  name: "LoginComponent",
  data() {
    return {
      username: "",
      password: "",
      valid: null,
      error: null,
      reqRules: [value => !!value || this.$t("string719")],
      emailRules: [
        value => !!value || this.$t("string719"),
        value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t("string724");
        }
      ]
    };
  },
  methods: {
    async submit() {
      await this.$refs.form.validate();
      if (this.valid) {
        await AuthService.login({
          username: this.username,
          password: this.password
        })
          .then(result => {
            this.$store.dispatch("setToken", result.data.token);
            this.$store.dispatch("setUser", result.data.user);
            localStorage.setItem("token", result.data.token);
            this.$router.push(this.$route.query.redirect || "/dashboard");
          })
          .catch(err => {
            this.error = err.response.data.errors;
          });
      }
    }
  }
};
</script>

<style scoped></style>
